import { createContext } from 'react';

import { NofomoCartStoreReturnType } from './zustand';

export const NofomoCartStoreContext =
  createContext<NofomoCartStoreReturnType | null>(null);
